import { useEffect, useState } from 'react';

/**
 * Garde un contenu MONTÉ le temps de son animation de fermeture.
 *
 * Pour un panneau replié en `grid-template-rows: 0fr → 1fr`, l'enveloppe
 * reste toujours dans le DOM (c'est elle qui transitionne) mais son contenu
 * n'a besoin d'exister que pendant qu'il est visible ou en train de se
 * refermer — sinon chaque heat replié porterait ses couloirs (et leurs
 * Draggables) en permanence.
 *
 * @returns `true` tant que le contenu doit être rendu.
 */
export function useDelayedUnmount(open: boolean, durationMs = 200): boolean {
  const [rendered, setRendered] = useState(open);

  useEffect(() => {
    if (open) {
      setRendered(true);
      return;
    }
    const timer = setTimeout(() => setRendered(false), durationMs);
    return () => clearTimeout(timer);
  }, [open, durationMs]);

  return open || rendered;
}
